import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Layout from 'components/Layout';

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: '23px 120px 166px 120px',
  },
  title: {
    fontSize: '50px',
    marginBottom: '22px',
  },
  update: {
    fontSize: '12px',
    marginBottom: '22px',
  },
  subTitle: {
    fontSize: '16px',
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    letterSpacing: '0.125rem',
    textTransform: 'capitalize',
    marginBottom: '0px!important',
    paddingTop: '0.5rem',
  },
  paragraphTitle: {
    fontSize: '19px',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginBottom: '0px!important',
    letterSpacing: '0.05rem',
    paddingTop: '0.5rem',
  },
  paper: {
    padding: '26px 149px',
    '& > *': {
      marginBottom: '1rem',
    },
  },
  logo: {
    width: '13rem',
    marginTop: '2rem',
    marginLeft: '0rem',
  },
  email: {
    color: theme.palette.secondary.main,
  },
}));
const PrivacyPolicy: React.FC = () => {
  const classes = useStyles();
  return (
    <Layout noMenu>
      <div className={classes.wrapper}>
        <Typography variant="h1" className={classes.title}>
          Politique de Confidentialité <br></br> et Cookies
        </Typography>
        <Typography className={classes.update}>Mise à jour le 01/04/2021</Typography>
        <Paper elevation={1} variant="outlined" className={classes.paper}>
          <Typography>
            CITEO, société anonyme, au capital de 499 444,50 euros, RCS Paris n° 388 380 073, dont le siège social est
            50 boulevard Haussmann, 75009 paris, France respecte votre vie privée et se conforme strictement à la
            réglementation en vigueur sur la protection des données personnelles.
          </Typography>
          <Typography>
            Ainsi, conformément à la Réglementation applicable en matière de données à caractère personnel et en
            particulier le Règlement (UE) 2016/679 du Parlement Européen et du Conseil du 27 avril 2016 relatif à la
            protection des personnes physiques à l'égard du traitement des données personnelles et à la libre
            circulation de ces données, ainsi que la Loi n° 78-17 du 6 janvier 1978 modifiée, relative à l'informatique,
            aux fichiers et aux libertés, vous êtes informé que CITEO est susceptible de mettre en œuvre plusieurs
            traitements de données à caractère personnel vous concernant en qualité de responsable de traitement.
          </Typography>
          <Typography>
            <strong>
              La présente politique vous informe de la manière dont CITEO recueille et gère vos données personnelles.
              Elle est susceptible d’être modifiée à tout moment, notamment en raison des modifications réglementaires
              et législatives.
            </strong>
          </Typography>
          <Typography>
            Une données personnelle désigne toute information se rapportant à une personne physique identifiée ou
            identifiable.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            TRAITEMENTS DE DONNÉES PERSONNELLES
          </Typography>
          <Typography variant="h5" className={classes.paragraphTitle}>
            Description des traitements sur vos données personnelles
          </Typography>
          <Typography>
            Les traitements mis en œuvre par CITEO répondent à des finalités explicites, légitimes et déterminées. Vos
            données sont collectées pour les durées précisées à la présente Politique. Il est néanmoins précisé que vos
            données peuvent être conservées pour des durées plus longues lorsque cela est nécessaire pour répondre à une
            obligation légale ou pour la défense des intérêts de CITEO. Dans cette hypothèse, vos données seront
            conservées pendant la durée nécessaire pour remplir cette obligation légale ou jusqu’à l’expiration du délai
            de prescription applicable.
          </Typography>
          <Typography>Vos données personnelles peuvent être traitées pour les finalités suivantes :</Typography>
          <Typography>
            <strong>
              <i>Inscription, utilisation de la Plateforme et gestion du flux développement – </i>
            </strong>
            Pour utiliser la Plateforme, vous devez disposer d’un compte utilisateur et renseigner un certain nombre
            d’informations personnelles : notamment données d’identification (identifiant de connexion, nom, prénom,
            adresse électronique, numéro de téléphone, adresse physique) et données professionnelles (fonction,
            entreprise, type de contact).
          </Typography>
          <Typography>
            En tant qu’utilisateur référent, vous pouvez également créer des profils d’utilisateurs pour vos
            collaborateurs en indiquant leur nom, prénom, adresse électronique et numéro de téléphone. Avant toute
            communication de données relatives à ses collaborateurs, l’utilisateur référent fait son affaire de
            l’information préalable de ces derniers quant à la communication de ces données à CITEO et s’engage à
            communiquer la présente Politique de confidentialité aux collaborateurs concernés pour leur parfaite
            information.
          </Typography>
          <Typography>
            Les informations requises pour vous inscrire et utiliser la Plateforme sont nécessaires afin de vous
            identifier et sont obligatoires pour la création du compte utilisateur. Elles vous permettent de bénéficier
            des services et fonctionnalités proposés sur la Plateforme. Ces informations nous permettent également de
            communiquer avec vous dans le cadre de la mise en œuvre et gestion de l’opérationnalité du flux
            développement.
          </Typography>
          <Typography>
            Ces traitements de données personnelles reposent sur l’exécution de nos obligations contractuelles et
            réglementaires dans le cadre de la mise en œuvre du flux développement et sur l’acceptation par
            l’Utilisateur des Conditions générales d’utilisation de la Plateforme au moment de la création de compte.
          </Typography>
          <Typography>
            Les données personnelles sont conservées jusqu’à la suppression du compte utilisateur et sont destinées au
            seul personnel habilité de CITEO ainsi qu’à ses prestataires sous-traitants, notamment les prestataires
            techniques de la Plateforme. Certaines données personnelles peuvent également être portées à la connaissance
            d’autres Utilisateurs de la Plateforme pour les besoins de la mise en œuvre de l’activité du flux
            développement.
          </Typography>
          <Typography>
            Les données personnelles nécessaires à l’exécution d’un contrat conclu entre CITEO et l’Utilisateur sont
            conservées pendant la durée du contrat et une durée maximale de cinq (5) ans à l’issue du terme du contrat.
          </Typography>
          <Typography>
            En cas d’inactivité du compte utilisateur pendant deux (2) ans, CITEO vous avertira de la suppression de
            votre compte par l’envoi d’un mail.
          </Typography>
          <Typography>
            <strong>
              <i>
                L’envoi de campagnes d’information et de newsletters (communications à caractère non commerciales) – 
              </i>
            </strong>
            Vos données d’identification sont susceptibles d’être utilisées pour vous adresser des campagnes
            d’information et newsletters liées à l’activité de reprise du flux développement.
          </Typography>
          <Typography>
            Ces opérations de communication répondent à l’intérêt légitime de CITEO de proposer des communications
            susceptibles de vous intéresser.
          </Typography>
          <Typography>
            Vous pouvez vous opposer à tout moment à la réception de ces communications en formulant par écrit une
            demande dans les conditions décrites ci-après ou en cliquant sur le lien de désinscription prévu à cet effet
            disponible sur chaque newsletter.
          </Typography>
          <Typography>
            Les données à caractère personnel communiquées sont destinées aux seules personnes habilitées de CITEO ainsi
            qu’à ses prestataires sous-traitants, notamment les prestataires techniques de la Plateforme.
          </Typography>
          <Typography>
            L’adresse mail peut être conservée pendant trois (3) ans à compter de la suppression du compte utilisateur
            ou du dernier contact émanant de la personne concernée ou jusqu’à l’exercice d’une demande d’opposition.
          </Typography>
          <Typography>
            <strong>
              <i>L’utilisation de vos métadonnées – </i>
            </strong>
            CITEO recueille des données de connexion, comme l’adresse IP, les identifiants de connexion, le type et les
            paramètres du navigateur, la date et l’heure des connexions des Utilisateurs afin de :
            <ul>
              <li>
                Permettre aux Utilisateurs de s’authentifier sur le compte utilisateur et sécuriser les connexions
                (cookies d’authentification)
              </li>
              <li>
                Déceler, éviter ou traiter des activités frauduleuses, des abus, des atteintes à la sécurité ou tout
                problème d’ordre technique rencontré par nos services (par exemple intrusion frauduleuse dans le système
                d’information).
              </li>
            </ul>
          </Typography>
          <Typography>
            Ces métadonnées sont recueillies sur la base de votre acceptation des Conditions générales d’utilisation de
            la Plateforme lors de création de votre compte utilisateur.
          </Typography>
          <Typography>
            Ces données sont uniquement destinées au personnel autorisé de CITEO ainsi qu’aux prestataires techniques de
            la Plateforme, le cas échéant.
          </Typography>
          <Typography>
            Ces informations ne sont pas conservées au-delà de 1 mois. Pour plus d’informations sur l’utilisation de
            cookies sur la Plateforme, vous pouvez vous référer à la section COOKIES ci-après.
          </Typography>
          <Typography>
            <strong>
              <i>Contacter CITEO – </i>
            </strong>
            Pour pouvoir répondre aux questions et réclamations, CITEO traite les informations liées à votre demande et
            vos données d’identification.
          </Typography>
          <Typography>
            Ce traitement repose sur l’intérêt légitime de CITEO à répondre aux diverses demandes pouvant être formulées
            par vous et vous aider, dans la mesure du possible, à résoudre les difficultés rencontrées. CITEO n’est pas
            en mesure de répondre à votre demande sans ces informations.
          </Typography>
          <Typography>
            Les données à caractère personnel communiquées sont destinées aux seules personnes habilitées de CITEO ainsi
            qu’à ses prestataires sous-traitants, notamment les prestataires techniques de la Plateforme.
          </Typography>
          <Typography>
            Ces informations sont conservées pendant la durée nécessaire pour donner suite à vos demandes.
          </Typography>
          <Typography>
            <strong>
              <i>Exercer vos droits RGPD – </i>
            </strong>
            Pour pouvoir exercer vos droits RGPD, vous devez communiquer vos données d’identification et une copie de
            votre pièce d’identité.
          </Typography>
          <Typography>
            Ces données sont nécessaires à CITEO afin de vous identifier pour permettre l’exercice de vos droits.
          </Typography>
          <Typography>
            Ce traitement repose sur l’obligation légale de CITEO de donner suite aux demandes des personnes concernées
            pour l’exercice de leurs droits.
          </Typography>
          <Typography>
            Les données à caractère personnel communiquées sont destinées aux seules personnes habilitées de CITEO ainsi
            qu’à ses prestataires sous-traitants, notamment les prestataires techniques de la Plateforme.
          </Typography>
          <Typography>
            Ces informations sont conservées pendant la durée nécessaire pour donner suite à vos demandes.
          </Typography>
          <Typography variant="h5" className={classes.paragraphTitle}>
            L’exercice de vos droits
          </Typography>
          <Typography>
            Conformément à la réglementation, vous disposez, sous certaines conditions, d’un droit d’interrogation,
            d’accès, de rectification, d’effacement, de limitation et de portabilité relativement à l’ensemble de vos
            données ainsi que du droit de formuler des directives spécifiques et générales concernant la conservation,
            l’effacement et la communication de vos données post-mortem.
          </Typography>
          <Typography>
            Vous pouvez également, lorsque le traitement de vos données est fondé sur notre intérêt légitime, vous
            opposer au traitement de vos données à caractère personnel. Vos données ne seront plus traitées par CITEO à
            moins qu’il existe des motifs légitimes et impérieux prévalant sur les intérêts et les droits et libertés de
            l’utilisateur, ou pour la constatation, l’exercice ou la défense de droits en justice.
          </Typography>
          <Typography>
            Ces droits peuvent être exercés auprès du délégué à la protection des données de CITEO par courrier
            électronique à <span className={classes.email}>dpd@citeo.com</span> ou par courrier à l’adresse suivante :
            CITEO – Délégué à la protection des données, 50 boulevard Haussmann, 75009 Paris, accompagné d’une copie
            d’un titre d’identité signé.
          </Typography>
          <Typography>
            Vous pouvez également, en cas de litige, saisir la Commission Nationale de l'Informatique et des Libertés
            (CNIL).
          </Typography>
          <Typography variant="h5" className={classes.paragraphTitle}>
            Les engagements de CITEO
          </Typography>
          <Typography>
            CITEO s’engage à traiter les données à caractère personnel, confiées et/ou collectées, dans le respect de la
            réglementation, et à cet égard, s’engage à :
            <ul>
              <li>
                Ne collecter et traiter les données à caractère personnel que conformément aux finalités liées à l’objet
                de la collecte ;
              </li>
              <li>Ne collecter et traiter les données que pendant la durée nécessaire au traitement ;</li>
              <li>
                Préserver la sécurité, l’intégrité et la confidentialité des données à caractère personnel collectées et
                traitées ;
              </li>
              <li>Ne pas transférer de données personnelles vers un pays hors Union européenne ;</li>
              <li>
                Mettre en place toute mesure technique et organisationnelle appropriées pour protéger les données à
                caractère personnel, en prenant en compte l'état des connaissances, les coûts de mise en œuvre et la
                nature, portée, contexte et les finalités du traitement ainsi que les risques, dont le degré de
                probabilité et de gravité varie, pour les droits et libertés des personnes physiques, afin de garantir
                un niveau de sécurité adapté au risque.
              </li>
            </ul>
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            COOKIES
          </Typography>
          <Typography>
            Les cookies correspondent à des petits fichiers texte qui peuvent être placés sur votre terminal
            (ordinateur, tablette, téléphone…) lorsque vous consultez un site ou une plateforme depuis Internet. Un
            fichier cookie permet d'identifier le terminal dans lequel il est enregistré, pendant la durée de validité
            ou d'enregistrement dudit cookie.
          </Typography>
          <Typography>
            Les cookies ont pour intérêt de faciliter votre navigation et de permettre à CITEO de sécuriser la
            navigation. La durée maximale de validité des cookies utilisés sur la Plateforme est de 1 mois.
          </Typography>
          <Typography>
            <strong>Cookies utilisés sur la Plateforme :</strong>
          </Typography>
          <Typography>
            Citeo n’utilise que des cookies strictement nécessaires pour permettre aux Utilisateurs d’utiliser la
            Plateforme :
          </Typography>
          <Typography>
            <strong>
              <i>Les cookies d’authentification – </i>
            </strong>
            Il s'agit de cookies de connexion qui permettent à l’Utilisateur d’accéder à son compte utilisateur de
            manière sécurisée. Ces cookies nous permettent d’assurer le bon fonctionnement de la Plateforme et de vous
            identifier lorsque vous vous connectez sur votre compte utilisateur. Ces cookies sont indispensables pour
            identifier et authentifier les Utilisateurs sur la Plateforme. Sans ces cookies vous ne pourriez pas accéder
            à votre compte utilisateur.
          </Typography>
          <Typography>
            Ces cookies permettent d’utiliser les fonctions de base de la Plateforme et sont donc toujours actifs. Ils
            ne nécessitent pas le consentement de l’Utilisateur.
          </Typography>
          <Typography>
            L’Utilisateur peut configurer son navigateur pour supprimer ou refuser systématiquement les cookies lors de
            sa navigation. Le refus systématique des cookies est susceptible d’affecter le bon fonctionnement de la
            Plateforme.
          </Typography>
          <Typography>
            Pour plus d’informations sur le paramétrage et la suppression des cookies, l’Utilisateur peut consulter le
            site de la CNIL ou les sites suivants selon son navigateur :
            <ul>
              <li>
                <a
                  className={classes.email}
                  href="https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chrome
                </a>
              </li>
              <li>
                <a
                  className={classes.email}
                  href="https://support.microsoft.com/fr-fr/help/17442/windows-internet-explorer-delete-manage-cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Internet Explorer
                </a>
              </li>
              <li>
                <a
                  className={classes.email}
                  href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences?redirectlocale=fr&redirectslug=activer-desactiver-cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Firefox
                </a>
              </li>
              <li>
                <a
                  className={classes.email}
                  href="https://help.opera.com/Windows/10.20/fr/cookies.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Opera
                </a>
              </li>
              <li>
                <a
                  className={classes.email}
                  href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Safari
                </a>
              </li>
            </ul>
          </Typography>
          <a target="_blank" rel="noopener noreferrer" href="https://www.citeo.com">
            <img className={classes.logo} alt="citeo" src="/citeo-text-logo.png" />
          </a>
        </Paper>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
